<div class="ko">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Könyveletlen órák</ion-card-title>
      <ion-card-subtitle>
        Naplóellenőrzés: kinek milyen eltelt órája nincs még beírva a naplóba (nincs témája vagy nincs könyvelve).
        Nem számít az elmaradt óra, a más által megtartott (helyettesített) óra, és a kolléga saját órája a távolléte
        (szabadság, betegség) napján – ugyanaz a szabály, mint a munkaidő-elszámolás nyomtatásánál.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="szurok">
        <div class="sor">
          <ion-input type="date" label="Ettől" label-placement="stacked" [(ngModel)]="tol" (ionChange)="toltes()"></ion-input>
          <ion-input type="date" label="Eddig" label-placement="stacked" [(ngModel)]="ig" [max]="adat?.ma" (ionChange)="toltes()"></ion-input>
          <ion-select label="Kolléga" label-placement="stacked" interface="popover" [(ngModel)]="tanar" (ionChange)="toltes()">
            <ion-select-option value="">Mindenki</ion-select-option>
            <ion-select-option *ngFor="let t of tanarok" [value]="t.adid">{{ t.nev }}</ion-select-option>
          </ion-select>
        </div>
        <div class="sor">
          <ion-chip (click)="gyors('honap')"><ion-label>Ez a hónap</ion-label></ion-chip>
          <ion-chip (click)="gyors('het')"><ion-label>Ez a hét</ion-label></ion-chip>
          <ion-chip (click)="gyors('elozo')"><ion-label>Előző hónap</ion-label></ion-chip>
          <span class="tolto"></span>
          <ion-button fill="outline" size="small" (click)="mindValt()" [disabled]="!adat?.kollegak?.length">
            <ion-icon slot="start" [name]="mindNyitva() ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
            {{ mindNyitva() ? 'Mind becsuk' : 'Mind kinyit' }}
          </ion-button>
          <ion-button fill="outline" size="small" (click)="pdf()" [disabled]="!adat || betolt || pdfKeszul">
            <ion-spinner *ngIf="pdfKeszul" slot="start" name="crescent"></ion-spinner>
            <ion-icon *ngIf="!pdfKeszul" slot="start" name="document-text-outline"></ion-icon>PDF
          </ion-button>
        </div>
      </div>

      <div *ngIf="betolt" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>
      <p class="hiba" *ngIf="hiba">{{ hiba }}</p>

      <ng-container *ngIf="adat && !betolt && !hiba">
        <!-- Üres állapot: minden be van írva. -->
        <div class="ures" *ngIf="!adat.kollegak.length">
          <ion-icon name="checkmark-done-circle-outline"></ion-icon>
          <h2>Minden óra be van írva</h2>
          <p class="halvany">
            {{ idoszakSzoveg() }}<span *ngIf="adat.tanar"> · {{ tanarNev() }}</span> – nincs könyveletlen óra.
          </p>
        </div>

        <ng-container *ngIf="adat.kollegak.length">
          <div class="osszeg">
            <div><b>{{ adat.konyveletlen }}</b><span>könyveletlen óra</span></div>
            <div><b>{{ adat.kollegak.length }}</b><span>érintett kolléga</span></div>
            <p class="halvany">{{ idoszakSzoveg() }}<span *ngIf="adat.tanar"> · {{ tanarNev() }}</span></p>
          </div>

          <div class="kollega" *ngFor="let k of adat.kollegak" [class.nyitott]="nyitva[k.adid]">
            <button type="button" class="fej" (click)="valt(k)" [attr.aria-expanded]="!!nyitva[k.adid]">
              <ion-icon [name]="nyitva[k.adid] ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
              <span class="nev">{{ k.nev }}</span>
              <span class="halvany">{{ k.napok }} nap</span>
              <ion-badge color="warning">{{ k.db }} óra</ion-badge>
            </button>
            <table class="lista" *ngIf="nyitva[k.adid]">
              <thead><tr><th>Nap</th><th>Óra</th><th>Időpont</th><th>Osztály / csoport</th><th>Tantárgy</th><th></th></tr></thead>
              <tbody>
                <tr *ngFor="let o of k.orak" [class.helyettesites]="o.helyettesites">
                  <td class="nw">{{ datumSzoveg(o.datum) }} <span class="halvany">{{ napNev(o.datum) }}</span></td>
                  <td class="nw">{{ oraSzoveg(o) }}</td>
                  <td class="nw halvany">{{ idopont(o) }}</td>
                  <td>{{ o.egyseg || '—' }}</td>
                  <td>{{ o.tantargy || '—' }}</td>
                  <td><ion-badge *ngIf="o.helyettesites" color="tertiary">{{ jeloles(o) }}</ion-badge></td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
